var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "18px",
    height: "18px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Ethereum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m15.82 0-.21.73v21.16l.21.21 9.82-5.8L15.82 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M15.82 0 6 16.3l9.82 5.8V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "m15.82 23.96-.12.15v7.54l.12.35 9.83-13.84-9.83 5.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M15.82 32v-8.04L6 18.16 15.82 32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m15.82 22.1 9.82-5.8-9.82-4.47V22.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m6 16.3 9.82 5.8V11.83L6 16.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereumLogo.d1ae0b0d5410e809a178a1ea001ca487.svg";
export { ForwardRef as ReactComponent };